import { useRouter } from 'next/router';
import { Box, Button, Card, Typography } from '@mui/material';
// Hooks
import { useWebiny } from '@/providers/WebinyProvider';
import { getSupportLinks } from '../../../constants';
import { brand } from '@/brand/brand';
// Styles
import styles from './download-card.module.css';
import { colors } from '@/theme';

export default function DownloadCard() {
  const router = useRouter();
  const { nodeSetupCard } = useWebiny();

  const nodeEngine = nodeSetupCard.platforms[0];
  const platforms = nodeSetupCard.platforms.slice(1);

  const handlePlatformClick = (platform) => {
    const brandName = brand.brandName?.toLowerCase();
    const platformTitle = platform.title?.toLowerCase();

    if (brandName && platformTitle) {
      const supportLinks = getSupportLinks(brandName.toLowerCase());
      const supportUrl = supportLinks[platformTitle];

      if (supportUrl) {
        // Open support link in new tab
        window.open(supportUrl, '_blank');
      } else {
        // Fallback to router.push
        router.push(platform.url);
      }
    } else {
      // Fallback to router.push if brand or platform title is missing
      router.push(platform.url);
    }
  };
  return (
    <Card sx={{ minWidth: '300px' }} elevation={1}>
      <div className={styles.cardHeaderRow}>
        <Typography
          variant="h5"
          className={styles.cardRowTitle}
          data-core-qa="nodesDownloadTitleText"
        >
          {nodeSetupCard.title}
        </Typography>
      </div>
      <div className={styles.nodeButton}>
        <Button
          fullWidth
          variant="store"
          sx={{
            display: 'flex',
            gap: '10px',
            padding: '5px',
            border: `1px solid ${colors.grey.light}`,
          }}
          onClick={() => window.open(nodeEngine.url, '_blank')}
          data-core-qa="buttonNodeEngine"
        >
          <img src={nodeEngine.iconAlt} alt="Block Fabric" height={52} />
          <Box
            sx={{
              borderRadius: '20px',
              backgroundColor: colors.primary.main,
              paddingLeft: '8px',
              paddingRight: '8px',
              fontSize: '12px',
              fontWeight: '500',
              color: 'white',
            }}
          >
            {nodeSetupCard.subTitle}
          </Box>
        </Button>
      </div>
      <div className={styles.downloadRow}>
        {platforms.map((platform) => (
          <Button
            key={platform.title}
            variant="store"
            onClick={() => handlePlatformClick(platform)}
            fullWidth
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              paddingTop: '10px',
            }}
            data-core-qa="buttonNavigate"
          >
            <img src={platform.icon} width={20} alt={`${platform.title} icon`} />{' '}
            {platform.title}
          </Button>
        ))}
      </div>
    </Card>
  );
}
